// extracted by mini-css-extract-plugin
export default {"container":"uGRdB","hasMargin":"KpzVB"};